import { Box, BoxProps, Text } from '@chakra-ui/react'
import { AiOutlineClose } from 'react-icons/ai'
import { FaCheck, FaRegComment } from 'react-icons/fa6'

interface TagStatusProps extends BoxProps {
  status: number
}

export const TagStatus: React.FC<TagStatusProps> = ({ status, ...rest }) => {
  const titulo = status === 0 ? 'Pendente' : status === 1 ? 'Solicitação de ajuste' : 'Assinado'
  const cor = status === 0 ? 'red.300' : status === 1 ? 'pink.300' : 'blue.300'
  const Icon: React.FC = status === 0 ? () => <AiOutlineClose size={15} color="white" /> : status === 1 ? () => <FaRegComment size={15} color="white" /> : () => <FaCheck size={15} color="white" />

  return (
        <Box display={'flex'} bgColor={cor} color="white" p={1} borderRadius="md" {...rest} gap={1} maxH={'24px'} alignContent={'center'} alignItems={'center'}>
            <Icon /> <Text fontSize={'sm'}>{titulo}</Text>
        </Box>
  )
}
